function str(v: unknown): string | undefined {
  if (v === null || v === undefined) return undefined;
  if (typeof v === "string") {
    const t = v.trim();
    return t.length ? t : undefined;
  }
  if (typeof v === "number" && Number.isFinite(v)) return String(v);
  return undefined;
}

export function materialsPedidoDisplayLabel(raw: unknown): string | undefined {
  const t = str(raw);
  if (!t) return undefined;
  if (/^sub\s*cotizaci[oó]n\s*(de\s+materiales)?$/i.test(t)) {
    return "Cotización de materiales";
  }
  if (/^sub\s*cotizaci[oó]n\b/i.test(t)) {
    const rest = t
      .replace(/^sub\s*cotizaci[oó]n\s*(de\s+materiales)?\s*[·\-–—:]\s*/i, "")
      .trim();
    if (rest) return `Cotización de materiales — ${rest}`;
    return "Cotización de materiales";
  }
  return t;
}
